import React from 'react';
import styled from '@emotion/styled';
import { FiltersRow, FiltersRowProps } from 'src/components-dummy';

export const FiltersRowStyled = styled((props: FiltersRowProps) => <FiltersRow {...props} />)`
  margin: 16px 0;
  flex: 9;
`;
